import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {getBaseURL} from 'src/utils/helper';

export const reportsApi = createApi({
    reducerPath: 'reportsApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/reports'),
    }),
    endpoints: () => ({}),
});